import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { CurrencyPipe, PercentPipe } from '@angular/common';
import { Meta } from '@angular/platform-browser';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideToastr } from 'ngx-toastr';
import { provideEnvironmentNgxCurrency, NgxCurrencyInputMode } from 'ngx-currency';

import { routes } from './app.routes';
import { AuthService } from './services/auth.service';
import { VersionCheckService } from './services/version-check.service';
import { AccessTokenInterceptor } from './utils/http-interceptor';

const currencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 2,
  prefix: '€ ',
  suffix: '',
  thousands: ',',
  nullable: false,
  min: null,
  max: null,
  inputMode: NgxCurrencyInputMode.Financial
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withEnabledBlockingInitialNavigation(),
      withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })
    ),
    provideAnimations(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    importProvidersFrom(
      LoggerModule.forRoot({
        serverLoggingUrl: '/api/v1/logs',
        level: NgxLoggerLevel.DEBUG,
        serverLogLevel: NgxLoggerLevel.INFO,
        disableConsoleLogging: true
      }),
    ),
    provideToastr({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      resetTimeoutOnDuplicate: true,
    }),
    provideEnvironmentNgxCurrency(currencyMaskConfig),
    AuthService,
    CurrencyPipe,
    Meta,
    PercentPipe,
    VersionCheckService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptor,
      multi: true,
    },
  ]
};
